import React, { useEffect, useState } from "react";
import moment from "moment";
import styled, { css } from "styled-components";
import Link from "../Link";
import classNames from "classnames";

const Comment = styled.div`
  display: flex;
  width: 700px;
`;

// If the client is viewing comments, then the clients comments are moved to the left.
// If the laboratory is viewing comments, then the laboratory comments are moved to the left.
const CommentContainer = styled.div`
  width: 100%;
  clear: both;
  margin-bottom: 10px;
  display: flex;
  ${props =>
    (props.labComment && props.labViewing) || (!props.labComment && !props.labViewing)
      ? css`
          justify-content: flex-start;
          .avatar-container {
            order: 0;
          }
        `
      : css`
          justify-content: flex-end;
          .avatar-container {
            order: 1;
          }
        `}
`;

export default function Comments({
  comments,
  clientView,
  handleExpire,
  }) {
  if (comments.length == 0) return null;

  const canAddAction = comment =>
    (clientView && !comment.laboratory) || (!clientView && comment.laboratory);
  const canDelete = comment => (clientView && !comment.laboratory) || !clientView;
  const showClientVisible = comment =>
    !clientView && comment.laboratory && comment.client_visible;

  return (
    <div className="comments-container" style={{ marginBottom: 10 }}>
      {comments.map(comment => (
        <CommentContainer
          key={comment.id}
          labComment={comment.laboratory}
          labViewing={!clientView}
        >
          <Comment>
            <div className="avatar-container flex-shrink-0">
              <div
                className={classNames("avatar", comment.laboratory ? "i2-avatar" : "comment-avatar")}
              />
              <div className="avatar-label">
                {comment.laboratory ? I18n.t("lab_user") : I18n.t("client")}
              </div>
            </div>
            <div style={{ padding: 10, width: "100%", paddingTop: 0 }}>
              {showClientVisible(comment) && (
                <span className="label label-visible-to-client">
                  {I18n.t("visible_to_client")}
                </span>
              )}
              <div
                className={classNames({
                  comment: true,
                  "comment-visible-to-client": showClientVisible(comment)
                })}
              >
                {comment.body}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 8,
                  fontSize: 12
                }}
              >
                <div className="subtext" style={{ color: "#747474" }}>
                  {comment.author} &nbsp;|&nbsp;{" "}
                  {moment(comment.created_at).format("DD/MM/YYYY  h:mm a")}
                </div>
                <div>
                  {canDelete(comment) && (
                    <Link onClick={() => handleExpire(comment.id)} style={{ color: "red" }}>
                      {I18n.t("delete")}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </Comment>
        </CommentContainer>
      ))}
    </div>
  );
}
